import React from 'react';
import styled from 'styled-components';
import { Icon, Text } from 'components';
import { formatTimeStr, formatDateStrWithYearAndDay } from 'utils';
import { Timezone } from '@bb/domain/dist/types';

type PreviousTimeInfoProps = {
  originalTime: string;
  originalTimeEnd: string;
  timezone: Timezone;
};
const PreviousTimeInfo: React.FC<PreviousTimeInfoProps> = ({
  originalTime,
  originalTimeEnd,
  timezone,
}) => {
  const originalDateStrWithYear = formatDateStrWithYearAndDay(
    originalTime,
    timezone,
  );
  const originalTimeStr = formatTimeStr(originalTime, timezone);
  const originalTimeEndStr = formatTimeStr(originalTimeEnd, timezone);

  return (
    <StyledContainer>
      <Icon type="antdInfoCircleFilled" />
      <Text type="secondary">
        {`Previously: ${originalDateStrWithYear} • ${originalTimeStr} - 
        ${originalTimeEndStr}`}
      </Text>
    </StyledContainer>
  );
};

export default React.memo(PreviousTimeInfo);

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 15px;
  gap: 5px;
`;
